import React from 'react';

export default function ReportsTable({ data }) {
    return (
        <table className={'point-table point-table--report'}>
            <tbody>
                {data?.metadata?.columns.map(c => {
                    return (
                        <tr key={c} align='left' className='reports-row'>
                            <td className='reports-leftCol'>{c}</td>
                            <td>{data?.rows[0][data?.metadata?.columns.indexOf(c)] || 0}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
